import { render, staticRenderFns } from "./indent.vue?vue&type=template&id=5c839d16"
import script from "./indent.vue?vue&type=script&lang=js"
export * from "./indent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports